export default __webpack_public_path__ + "static/media/sellers.c4bda761.svg";